module.exports = __webpack_public_path__ + "img/2021_MarcoMarcia.919d6568.png";